// Форматирование: суммы приходят в копейках.

const RUB = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });
const QTY = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 3 });
const TIME = new Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit' });
const DAY = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'short' });
const WEEKDAY = new Intl.DateTimeFormat('ru-RU', { weekday: 'short', day: 'numeric', month: 'short' });

export const formatKop = (kop: number) => `${RUB.format(Math.round(kop / 100))} ₽`;
export const formatQty = (v: number) => QTY.format(v);
export const formatPct = (n: number) => `${n.toLocaleString('ru-RU', { maximumFractionDigits: 1 })} %`;
export const formatTime = (iso: string) => TIME.format(new Date(iso));
export const formatDay = (iso: string) => DAY.format(new Date(iso));
export const formatWeekday = (iso: string) => WEEKDAY.format(new Date(iso));

export function formatDuration(ms: number): string {
  const totalMin = Math.round(ms / 60_000);
  if (totalMin < 1) return 'меньше минуты';
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  if (h === 0) return `${m} мин`;
  return m === 0 ? `${h} ч` : `${h} ч ${m} мин`;
}

export function formatWhen(iso: string): string {
  const d = new Date(iso);
  const today = new Date();
  const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
  if (d.toDateString() === today.toDateString()) return `сегодня ${TIME.format(d)}`;
  if (d.toDateString() === yesterday.toDateString()) return `вчера ${TIME.format(d)}`;
  return `${DAY.format(d)} ${TIME.format(d)}`;
}

export function plural(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(n) % 100;
  const last = abs % 10;
  if (abs > 10 && abs < 20) return many;
  if (last > 1 && last < 5) return few;
  if (last === 1) return one;
  return many;
}

/** Рубли из поля ввода («1 250,5») в копейки; пусто или мусор — null. */
export function parseRub(raw: string): number | null {
  const n = Number(raw.replace(/\s/g, '').replace(',', '.'));
  return Number.isFinite(n) && n >= 0 ? Math.round(n * 100) : null;
}

/** Товар на вес/объём — можно дробное количество. */
export function isFractionalUnit(unit: string): boolean {
  return /^(кг|г|л|мл|м)\.?$/i.test(unit.trim());
}

export function uid(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID();
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
